import { render, staticRenderFns } from "./PaystackTransactionDetail.vue?vue&type=template&id=4d97b00c&scoped=true"
import script from "./PaystackTransactionDetail.vue?vue&type=script&lang=js"
export * from "./PaystackTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./PaystackTransactionDetail.vue?vue&type=style&index=0&id=4d97b00c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d97b00c",
  null
  
)

export default component.exports